import React, { useEffect, useRef } from 'react';
import { motion, useAnimation, useInView } from 'framer-motion';
import Gallery from 'pages/community/gallery';

export default function JoinCommunityCta() {
  const sectionRef = useRef(null);

  const controls = useAnimation();

  const isInView = useInView(sectionRef, { once: true, threshold: 0.2 });

  useEffect(() => {
    if (isInView) {
      controls.start('visible');
    }
  }, [controls, isInView]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.6,
        staggerChildren: 0.2,
      },
    },
  };

  const childVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut',
      },
    },
  };

  const hrVariants = {
    hidden: { width: 0 },
    visible: {
      width: 'calc(100% - 5rem)',
      transition: {
        duration: 0.8,
        ease: 'easeOut',
      },
    },
  };

  return (
    <motion.section
      ref={sectionRef}
      className="join-community py-10 px-6 lg:px-16"
      initial="hidden"
      animate={controls}
      variants={containerVariants}
    >
      <motion.h1
        className="text-left max-w-2xl lg:max-w-sm text-3xl lg:text-5xl pt-4 lg:pt-6 tracking-normal font-medium"
        variants={childVariants}
      >
        Want to Join Our{' '}
        <span className="font-serif italic text-secondary font-semibold">
          Community?
        </span>
      </motion.h1>
      <motion.p
        className="lg:max-w-xl py-3 lg:py-5 text-text-color text-base font-medium"
        variants={childVariants}
      >
        Come connect with ambitious women like you — learning, growing, and
        winning together with Shecluded by your side.
      </motion.p>
      <motion.a
        href="https://chat.whatsapp.com/KNjaEnbf4zl5NFRKcTrsLW"
        className="inline-flex items-center rounded-full bg-text-color py-3 px-20 text-sm/6 lg:text-base font-medium text-light-grey-4 drop-shadow-lg transition duration-0 ease-in hover:drop-shadow-xl hover:duration-150"
        variants={childVariants}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        Join Now
      </motion.a>
      <motion.hr
        className="my-8 border-1 border-light-grey-1 mr-20"
        variants={hrVariants}
      />
      <Gallery />
    </motion.section>
  );
}
